import React from "react";
import { Link } from "react-router-dom";
import { removeSpaces } from "../utills/CommonData";

const ProductCard = ({ item }) => {
  const { id, image, name, category, sub_category } = item;
  return (
    <div key={id} className="lg:w-56 w-52 ">
      <Link
        to={`/products/${removeSpaces(category)}/${removeSpaces(
          sub_category
        )}/${id}`}
        state={{ item }}
        className="flex flex-col gap-3 p-3 w-full items-center justify-center"
      >
        <div className="xl:h-52 h-48 lg:w-56 w-52 group overflow-hidden relative">
          <img
            src={image}
            className="h-full w-full object-cover rounded group-hover:scale-110 duration-300 ease-in-out"
            alt={name}
          />
        </div>

        <h3 className="line-clamp-2 w-full hover:underline duration-300 ease-in-out">
          {name}
        </h3>
      </Link>
    </div>
  );
};

export default ProductCard;
